import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export enum Operators {
  DF = -1, // Default
  LT = 0,
  LTE = 1,
  EQ = 2,
  NEQ = 3,
  GT = 4,
  GTE = 5,
  OPEN = 6,
  CLOSED = 7,
  EITHER = 8,
}

export enum HysteresisMode {
  NONE = 0,
  ABSOLUTE = 1,
  PERCENTAGE = 2,
}
export interface Hysteresis {
  value: number;
  mode: HysteresisMode;
}
export interface RulesSpec {
  id?: string;
  notificationID?: string;
  device_eui?: string;
  parameter?: string;
  operator?: Operators;
  threshold?: number | string;
  hysteresis?: Hysteresis;
}
export interface Status {
  active: boolean;
  current?: boolean;
  triggered?: boolean;
  triggered_at?: Date;
  last_trigger?: Date;
  evaluated_at?: Date;
  acknowledged_at?: Date;
}
export interface RuleStatus {
  changed_at?: Date;
  state?: boolean;
  value?: number;
  previousState?: boolean;
}
export interface Rule {
  id?: string;
  spec?: RulesSpec;
  status?: RuleStatus;
}

export type Rules = Rule[] | Record<string, Rule>;
export interface Email {
  subject: string | null;
  body: string | null;
  trigger: Date;
}
export interface Configuration {
  repeat_interval: number;
  hold_on: number;
  hold_off: number;
  assert_on: boolean;
  latch_on: boolean;
}
export interface NotificationState {
  id?: string;
  group_id: string;
  name: string;
  users: string[];
  rules: Rules;
  email: Email;
  configuration?: Configuration;
  status?: Status;
  dashboard?: string;
}

const initialState: NotificationState[] = [];

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<NotificationState[]>) =>
      action.payload,
    removeNotification: (state, action: PayloadAction<string>) => {
      const index = state.findIndex((notification) => notification.id === action.payload);
      if (index !== -1) state.splice(index, 1);
    },
  },
});

export const { setNotifications, removeNotification } = notificationSlice.actions;
export const selectNotifications = (state: RootState) => state.notifications;
export const selectNotificationByID = (
  state: RootState,
  notificationID: string
): NotificationState | null => {
  const notification = state.notifications.find(
    (notification) => notification.id === notificationID
  );
  return notification || null;
};

export const selectIsNotification = (
  state: RootState,
  notificationID: string
): boolean => {
  return state.notifications.some((notification) => notification.id === notificationID);
};

export default notificationSlice.reducer;
